export const handleUpgradeToUnlock = (history:any) => {
    history.push('/plan');
};